import React from 'react';
import AppService from '../service/AppService';
import AppConfigService from '../service/AppConfigService';
import AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

export default class Brand extends React.Component {

  render() {
    let logoClassName = 'logo';
    let url = appConfig.mainPage;
    let disableLogoLink = false;
    if (appConfig.isAperzaCatalog) {
      logoClassName = 'logo-catalog';
      url = `${appConfig.searchWebHost}${appConfig.langCode=='ja'?'':'/'+appConfig.langCode}/catalog`;
    } else if (appConfig.isAperzaMarketplace || AppConfigService.shouldShowMarketplaceTopBanner()) {
      if (appConfig.langCode == 'en') {
        logoClassName = 'logo-ec-en';
      } else {
        logoClassName = 'logo-ec-ja';
      }
      url = `${appConfig.mainPage}`;
    } else if (appConfig.serviceType == AppConfig.APERZA_NEWS) {
      logoClassName = 'logo-news';
      url = `//news${appConfig.baseDomain}`;
    } else if (appConfig.isAperzaIdDomain) {
      logoClassName = 'logo-id';
      url = `${appConfig.aperzaIdHost}`;
    } else if (appConfig.isAperzaAccountDomain) {
      logoClassName = 'logo-id';
      url = `${appConfig.aperzaAccountHost}`;
    } else if (appConfig.isAperzaOrderDomain) {
      logoClassName = 'logo-ec-ja';
      url = `${appConfig.marketplaceWebHost}`;

      if (AppConfigService.isOrderCheckout() || AppConfigService.isOrderRegister()) {
        disableLogoLink = true;
      }
    } else if (appConfig.isAperzaBusinessDomain) {
      logoClassName = 'logo-ec-ja';
      url = `${appConfig.marketplaceWebHost}`;

      if (AppConfigService.isBusinessSignup()) {
        disableLogoLink = true;
      }
    }

    if ( disableLogoLink) {
      return (
        <div className="logo-container">
            <div className={logoClassName} />
        </div>
      )
    } else {
      return (
        <div className="logo-container">
          <a href={url} target="_self">
            <div className={logoClassName} />
          </a>
        </div>
      )
    }

  }

}